import styled from '@emotion/styled'
import { css } from '@emotion/css'
import { AtlasActionPrimary, ColorBaseSkyBlue } from 'assets/styles/variables'

export const ToastContainer = styled('div')`
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 10px;
`
export const HeaderText = styled('span')`
    font-size: 22px;
    font-weight: 600;
    padding-left: 5px;
`
export const ProgressMessage = styled('p')`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-weight: 400;
    padding: 20px;
    line-height: 20px;
`
export const TranscriptProgressMessage = styled('p')`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-weight: 400;
    padding: 32px;
    line-height: 20px;
`
export const Link = styled('a')`
    color: #455d82;
    font-weight: 700;
`

export const ToolbarCss = css`
    display: flex;
    gap: 16px;
    align-items: center;
`
export const ToolbarBoxCss = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border: 1px solid #e6e6e6;
`
export const listSubheader = css`
    z-index: 110;
    padding-left: 0;
    padding-right: 0;
`
export const aiDialogContainer = css`
    padding-bottom: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
`

export const aiDialogHeader = css`
    display: flex;
    align-items: center;
    height: 58px;
    padding: 16px;
`
export const aiDialogHeaderWithGradient = css`
    display: flex;
    align-items: center;
    height: 58px;
    padding: 16px;
    position: relative;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1.5px;
        opacity: 0.8;
        background: linear-gradient(90deg, #be0c1e 0%, #ab48da 50%, #4069fe 100%);
    }
    &::before {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;
        height: 12px;
        opacity: 0.25;
        filter: blur(20px);
        background: linear-gradient(
            90deg,
            rgba(226, 226, 229, 0) 0%,
            #be0c1e 15%,
            #ab48da 50%,
            #4069fe 85%,
            rgba(226, 226, 229, 0) 100%
        );
        pointer-events: none;
    }
`
export const aiGenerateFooter = css`
    display: flex;
    gap: 10px;
    padding: 10px 20px;
    justify-content: space-between;
    align-items: center;
`
export const customButton = css`
    display: flex;
    align-items: center;
    text-transform: none;
    font-size: 16px;
    font-weight: 600;
    padding: 8px 12px;
`

export const aiGeneratedNotification = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    min-width: 700px;
    max-width: 1090px;
    margin: 24px auto;
`
export const aiGeneratedNotificationBody = css`
    display: flex;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    border-radius: 8px;
    justify-content: space-between;
`
export const aiGeneratedNotificationContent = css`
    display: flex;
    align-items: center;
    gap: 3px;
    align-self: stretch;
    border-radius: 8px;
`
export const btnDismiss = css`
    color: ${AtlasActionPrimary};
    height: 40px;
    span {
        font-family: 'Source Sans Pro';
        font-weight: 600;
        font-size: 16px;
        text-transform: capitalize;
    }
    :focus {
        box-shadow: 0px 0px 0px 1px #ffffff, 0px 0px 0px 3px ${ColorBaseSkyBlue};
        border-radius: 2px;
    }
`
